import { Box } from '@mui/material'
import { DinamicForm } from '../../../../../components/dinamicForm'
import Loader from '../../../../../components/loader'
import { useStyles } from './styles'

const Form = ({ btnLoading, data, input, crudChange, allErrors }: any) => {
  const styles = useStyles()

  return btnLoading ? (
    <Box sx={styles.loader}>
      <Loader />
    </Box>
  ) : (
    <Box sx={styles.container}>
      <DinamicForm input={input} values={data} onChange={crudChange} errors={allErrors} />
    </Box>
  )
}

export default Form
